<template>
    <span
        class="inline-flex shrink-0"
        :role="ariaLabel ? 'img' : undefined"
        :aria-label="ariaLabel"
        :aria-hidden="ariaLabel ? undefined : 'true'"
    >
        <svg
            v-for="index in count"
            :key="`star-${index}`"
            :width="size"
            :height="size"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path :d="STAR_PATH" />
        </svg>
    </span>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    count?: number,
    size?: string,
    ariaLabel?: string
}>(), {
    count: 5,
    size: '1em',
    ariaLabel: undefined
})

/** Stars inherit currentColor so they stay readable on every promo bar variant */
const STAR_PATH = 'M12 1 L14.47 8.6 L22.46 8.6 L16 13.3 L18.47 20.9 L12 16.2 L5.53 20.9 L8 13.3 L1.54 8.6 L9.53 8.6 Z'
</script>
